export default class TranscriptCourseLiteDomainService {
    static fromJSON(json) {
        return Object.assign(Object.assign({}, json), { lastAttendanceDate: json.lastAttendanceDate && new Date(json.lastAttendanceDate) });
    }
}
